import axios from 'axios';

export const sendEmail = (subject: string, body: string, tos: string) => {
  return axios.post(`${window.functionsUrl}notifyEmail`, {
    subject,
    body,
    tos,
  });
};

export const sendWa = (message: string, to?: string) => {
  return axios.post(`${window.functionsUrl}sendWhatsApp`, { to, message });
};
